import React from "react"

interface ProgressBarProps {
  currentStep: number
  totalSteps: number
}

export function ProgressBar({
  currentStep,
  totalSteps,
}: ProgressBarProps): JSX.Element {
  const percentage =
    totalSteps === 0
      ? 0
      : Math.min(100, Math.round((currentStep / totalSteps) * 100))

  return (
    <div className="h-7 bg-csw-progress-track" aria-label="Progress">
      <div
        className="h-7 bg-csw-progress flex items-center justify-end"
        style={{ width: `${percentage}%` }}
      >
        <span className="text-white px-4">{percentage}%</span>
      </div>
    </div>
  )
}
